// extracted by mini-css-extract-plugin
module.exports = {"container":"SplitRoom_container__2bK8W","newOwner":"SplitRoom_newOwner__1yiIt","bill-table":"SplitRoom_bill-table__1nABS"};